__turbopack_context__.v({
  "setStoreButton": "StoreAvailabilityToggle-module-scss-module__HQKj6q__setStoreButton",
  "textLine": "StoreAvailabilityToggle-module-scss-module__HQKj6q__textLine",
  "wrapper": "StoreAvailabilityToggle-module-scss-module__HQKj6q__wrapper",
});
